export default __webpack_public_path__ + "static/media/opsee.25fc9da4.svg";